export * from './view';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uirouter/core/lib-esm/view/index.js
// module id = 2095
// module chunks = 2